import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ObtenerHectometrosMacroubicacion = async (values) => {
    try {
        const resultado = await instance.Backend.post("/InformeConservacion/ObtenerHectometrosMacroubicacion",values, customConfig);

        return resultado

    } catch (error) {

        console.log(error);

    }

}
export { ObtenerHectometrosMacroubicacion };
